export default {
  relatorio: {
    relatorio: 'Informe',
    graosProdutor: 'Granos por productor',
    regiao: 'Región',
    municipio: 'Contacto',
    sim: 'Si',
    nao: 'No',
    carregando: 'Cargando...',
    gerandoRelatorio: 'Generando informe ...',
    falhaAoGerarRelatorio: 'Error al generar informe',
    dataLancamento: 'Fecha de lanzamiento',
    tecnicoResponsavel: 'Técnico responsable',
    produtor: 'Productor',
    uf: 'UF',
    decrescente: 'Disminuyendo',
    crescente: 'Creciente',
    media: 'Promedio',
    minimoFiltro: 'Aplicar al menos un filtro',
    mensagemSemFiltro: 'Sin un filtro de productor, el informe puede tardar mucho tiempo en continuar?',
    estado: 'State',
    comunidade: 'Comunidad',
    safra: 'Clásico',
    cultura: 'Cultura',
    periodo: 'Período',
    baixarCSV: 'Descargar CSV'
  }
};
